module.exports = __webpack_public_path__ + "img/Zug.194076b3.svg";